import * as React from 'react'
import { ReactElement } from 'react'
import TimeReportForm from '../../components/Form/Finance/Report/TimeReportForm'
import TierReportForm from '../../components/Form/Finance/Report/TierReportForm'
import InvoiceReportForm from '../../components/Form/Finance/Report/InvoiceReportForm'
import { Stack } from '@fluentui/react'
import FilesPerUserReportForm from '../../components/Form/Finance/Report/FilesPerUserReportForm'
import BilledTurnoverReportForm from '../../components/Form/Finance/Report/BilledTurnoverReportForm'
import OngoingFilesReportForm from '../../components/Form/Finance/Report/OngoingFilesReportForm'
import OutstandingInvoicesForm from '../../components/Form/Finance/Report/OutstandingInvoicesForm'
import UserProductivityForm from '../../components/Form/Finance/Report/UserProductivityReportForm'
import WipReportForm from '../../components/Form/Finance/Report/WipReportForm'
import PartyCardReportForm from '../../components/Form/Finance/Report/PartyCardReportForm'
import useModules from '../../hooks/module/useModules'
import { ModuleType } from '../../context/GlobalContext'

export default function Reports(): ReactElement {
    const modules = useModules()

    return (
        <Stack horizontal horizontalAlign="start" wrap tokens={{ childrenGap: 16 }}>
            <TimeReportForm />
            <OutstandingInvoicesForm />
            <BilledTurnoverReportForm />
            <UserProductivityForm />
            {modules.has(ModuleType.WorkInProgress) && <WipReportForm />}
            <OngoingFilesReportForm />
            <InvoiceReportForm />
            <TierReportForm />
            <FilesPerUserReportForm />
            <PartyCardReportForm />
        </Stack>
    )
}
